export default "__VITE_ASSET__DgTmij61__"